import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login.service';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {
  loading: boolean;
  loginError: boolean;
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
    private snackBar: MatSnackBar
  ) {
    this.loginError = false;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //console.log('sso.component - params.token: ' + params.token)
      //console.log('sso.component - authtoken: ' + sessionStorage.getItem('authenticationToken'))
      if (!sessionStorage.getItem('authenticationToken')) {
        /* Si no hay token, fuera */
        if (!params.token) {
          console.error('Token no provisto en la ruta');
          this.router.navigate(['/login']);
        }
        sessionStorage.setItem('ssoToken', params.token);
        this.loading = true;
        this.loginService
          .loginSSO(params.token)
          .pipe(first())
          .subscribe(
            data => {
              this.loginService.loggedFromSSO = true;
              this.router.navigate(['/']);
            },
            error => {
              this.loading = false;
              this.loginError = true;
            }
          );
      }
    });
  }

  closeWindow() {
    window.close();
  }
}
